import React, { useState, useEffect, useRef } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import NewsTable from './NewsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic/';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import NewsModal from '../../../PublicPages/HomePage/NewsDetail/NewsItem/NewsModal/NewsModal.jsx';
import { formattedFullName } from '../../../../../utils/helpers/CommonHelper';
import { GroupOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
  useGetNewsDetailQuery,
  useGetNewsEditQuery,
  useDeleteNewsMutation,
} from '../../../../../redux/services/news';
import { isNull } from 'lodash';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const NewsPages = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const languageType = useRef(null);

  useEffect(() => {
    document.title = t('Aktuality') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess } = useToastMessages();

  const [newsInPreviewId, setNewsInPreviewId] = useState(null);

  const { data: news, isLoading, refetch } = useGetNewsEditQuery();

  const { data: newsInPreviewDetail, isFetching: isLoadingNewsPreview } =
    useGetNewsDetailQuery(newsInPreviewId, {
      skip: isNull(newsInPreviewId),
    });

  const [deleteNews, { isSuccess: isDeleteSuccess }] = useDeleteNewsMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      saveSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Aktuality')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať aktualitu')}
        createUrl={routes.cmsNewsCreate}
        permissionsBasic={'news'}
        mainActions={[
          {
            onClick: () => navigate(routes.cmsNewsCategories),
            title: t('Kategórie aktualít'),
            icon: <GroupOutlined />,
            permission: 'news-categories.index',
          },
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <NewsTable
            //news={news}
            news={Array.isArray(news) ? news : news?.data || []}
            onDelete={(record) => deleteNews(record.id)}
            onEditClick={(record) =>
              navigate(`${routes.cmsNewsEdit}/${record.id}`)
            }
            onPreviewClick={(record, type) => {
              setNewsInPreviewId(record.id);
              languageType.current = type
                ? type
                : record.title_sk
                  ? 'sk'
                  : 'en';
            }}
          />
        </CollapseBlock>
      </div>

      {!isNull(newsInPreviewId) && (
        <NewsModal
          isLoading={isLoadingNewsPreview}
          visible
          toggleModal={() => setNewsInPreviewId(null)}
          content={newsInPreviewDetail?.[`content_${languageType.current}`]}
          title={newsInPreviewDetail?.[`title_${languageType.current}`]}
          dateOfCreate={dayjs(
            newsInPreviewDetail?.created_at || new Date(),
          ).format('D.MM.YYYY h:mm')}
          creatorName={formattedFullName(newsInPreviewDetail?.person)}
        />
      )}
    </>
  );
};

export default NewsPages;
